// extracted by mini-css-extract-plugin
module.exports = {"term-condition":"term-condition","termCondition":"term-condition"};